import Slideshow from "../slideshow/slideshow.js"

class ProductImgSlideShow extends Slideshow {
  constructor(el) {
    super(el)
  }
}

export default ProductImgSlideShow
